<template>
  <div class="rk-table__resize" style="width: 5px" data-name="resize" @mousedown="mousedown"></div>
</template>

<script>
export default {
  props: ['index'],
  data() {
    return {
      width: 0,
      pageX: 0,
      isDown: false
    }
  },
  mounted() {
    window.addEventListener('mousemove', this.mousemove)
    window.addEventListener('mouseup', this.mouseup)
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.mousemove)
    window.removeEventListener('mouseup', this.mouseup)
  },
  methods: {
    mousedown(e) {
      this.width = e.target.parentElement.offsetWidth
      this.pageX = e.pageX
      this.isDown = true
    },
    mousemove(e) {
      if (!this.isDown) return
      this.$parent.updateColumnWidth(this.width + (e.pageX - this.pageX), this.index)
    },
    mouseup() {
      if (this.isDown) {
        this.isDown = false
      }
    }
  }
}
</script>

<style scoped>
.rk-table__resize {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  cursor: col-resize;
}
</style>
